import { cap } from '../../State'
import quotesType from '../../State/quotesType'
import { translations } from '../../translations'
import { showToast } from '../../utils/toast'

const language = cap.language.state || 'IT'
const t = translations[language]

export const alert = showToast
export const services = quotesType

export const planeTrainCoefficient = {
  Base: [
    {
      code: 'coefficienteDurata',
      name: t.mxCoeffDurata,
      value: 0.1
    },
    {
      code: 'coefficienteScostamento',
      name: t.mxCoeffScostamento,
      value: 0.1
    }
  ]
}

export const hotelCoefficientState = {
  Base: [
    {
      code: 'coefficienteDistanza',
      name: t.mxCoeffDistanza,
      value: 0.1
    }
  ],
  Corporate: [
    {
      code: 'coefficienteTariffaPubblica',
      name: t.mxTariffaPubblica,
      value: 1
    },
    {
      code: 'coefficienteTariffaAgenzia',
      name: t.mxTariffaAgenzia,
      value: 0.9
    },
    {
      code: 'coefficienteTariffaCliente',
      name: t.mxTariffaCliente,
      value: 0.95
    }
  ],
  Trattamento: [
    {
      code: 'ro',
      name: t.mxRoomOnly,
      value: 0.2
    },
    {
      code: 'bb',
      name: t.mxBedAndBreakfast,
      value: 0.2
    },
    {
      code: 'hb',
      name: t.mxMezzaPensione,
      value: 0.13
    },
    {
      code: 'fb',
      name: t.mxPensioneCompleta,
      value: 0.12
    },
    {
      code: 'dn',
      name: t.mxCenaInclusa,
      value: 0.12
    },
    {
      code: 'ln',
      name: t.mxPranzoIncluso,
      value: 0.12
    },
    {
      code: 'al',
      name: t.mxAllInclusive,
      value: 0.12
    }
  ],
  'Livelli Hotel Program': [
    {
      code: 'coefficienteHotelProgram0',
      name: t.mxLivello0,
      value: 1
    },
    {
      code: 'coefficienteHotelProgram1',
      name: t.mxLivello1,
      value: 0.85
    },
    {
      code: 'coefficienteHotelProgram2',
      name: t.mxLivello2,
      value: 0.9
    },
    {
      code: 'coefficienteHotelProgram3',
      name: t.mxLivello3,
      value: 0.95
    }
  ]
}

export const prepareStates = (json, service) => {
  const s = quotesType.find((serv) => serv.id === service)
  const finalState = []
  s.filters.forEach((filter) => {
    finalState.push({ type: filter.name, ...json })
  })
  return finalState
}
